import createRoute      from '@widesk-ui/tools/createRoute';
import DeliverableModel from '@models/shop/DeliverableModel';

export default createRoute.splitView('/entertainments/:entertainmentId/deliverables', 'shop', 'DeliverableSplitView', DeliverableModel.localize('plural'));
